import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section aria-label="Key facts" className="w-full border-y border-white/10 bg-ink-900 px-4 py-8 sm:px-6" data-id="element-218" data-mp="1tarjq9bipqkw">
      <div className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-4" data-id="element-219" data-mp="1oavqn54czjk4">
        {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-220" data-mp="1jbiutuvif25e">
            <p className="font-display text-2xl text-lime sm:text-4xl" data-id="element-221" data-mp="1ecz7pr56jkbg">{stat.value}</p>
            <p className="mt-1 text-[11px] font-semibold uppercase tracking-wider text-white/55 sm:text-xs" data-id="element-222" data-mp="19misc1hstomg">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}